import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { PropertiesDebt } from 'src/common-services'
import { Flex, FlexColumn } from 'src/components/flex-containers'
import { PropertyRecordAccordion } from 'src/components/insights/property-records/property-record-accordion'
import { Grid, Typography } from '@mui/material'
import { formatVal } from 'src/utils/number-format'
import { GridPairKey, GridPairValue } from 'src/components/grid-pair'
import { UnavailableCardContent } from 'src/components/insights/unavailable-card-content'
import { formatString } from 'src/utils/format-string'

const Wrapper = styled(FlexColumn)`
  gap: ${Shapes.spacing[4]}px;
  padding-inline: ${Shapes.spacing[4]}px;
`

const TitleWrapper = styled(Flex)`
  width: 100%;
  gap: ${Shapes.spacing[4]}px;
`
const TitleColumn = styled(FlexColumn)`
  flex: 1;
  gap: ${Shapes.spacing[2]}px;
`

const SectionContent = styled(Flex)``
const SectionColumn = styled(FlexColumn)`
  .MuiGrid-item {
    padding-bottom: ${Shapes.spacing[4]}px;
  }
`

const Debt = (props: { debt: PropertiesDebt }) => {
  const { debt } = props

  const header = (
    <TitleWrapper>
      <TitleColumn gap={Shapes.spacing[2]}>
        <Typography variant="textmdm" color={Colors.textMedium}>
          Date
        </Typography>
        <Typography variant="textmd" color={Colors.textBlack}>
          {debt.date || '-'}
        </Typography>
      </TitleColumn>
      <TitleColumn gap={Shapes.spacing[2]}>
        <Typography variant="textmdm" color={Colors.textMedium}>
          Maturity Date
        </Typography>
        <Typography variant="textmd" color={Colors.textBlack}>
          {debt.maturityDate || '-'}
        </Typography>
      </TitleColumn>
      <TitleColumn gap={Shapes.spacing[2]}>
        <Typography variant="textmdm" color={Colors.textMedium}>
          Lender
        </Typography>
        <Typography variant="textmd" color={Colors.textBlack}>
          {formatString(debt.lender, 'name')}
        </Typography>
      </TitleColumn>
      <TitleColumn gap={Shapes.spacing[2]}>
        <Typography variant="textmdm" color={Colors.textMedium}>
          Amount
        </Typography>
        <Typography variant="textmd" color={Colors.textBlack}>
          {formatVal(debt.amount, 'currency-expanded')}
        </Typography>
      </TitleColumn>
    </TitleWrapper>
  )
  return (
    <PropertyRecordAccordion
      title={header}
      content={
        <SectionContent>
          <SectionColumn
            style={{
              flex: 1,
            }}>
            <Grid container>
              <GridPairKey>Mortagage Type</GridPairKey>
              <GridPairValue>{debt.documentType || '-'}</GridPairValue>
              <GridPairKey>Interest Rate</GridPairKey>
              <GridPairValue>{debt.interestRate || '-'}</GridPairValue>
              <GridPairKey>Interest Type</GridPairKey>
              <GridPairValue>{debt.interestType || '-'}</GridPairValue>
            </Grid>
          </SectionColumn>
          <SectionColumn
            style={{
              flex: 1,
            }}>
            <Grid container>
              <GridPairKey>Term</GridPairKey>
              <GridPairValue>{debt.term || '-'}</GridPairValue>
              <GridPairKey>Document #</GridPairKey>
              <GridPairValue>{debt.documentNumber || '-'}</GridPairValue>
              <GridPairKey>Seller Carry Back</GridPairKey>
              <GridPairValue>{debt.sellerCarryBack || '-'}</GridPairValue>
            </Grid>
          </SectionColumn>
        </SectionContent>
      }
    />
  )
}

export const PropertyRecordsDetailsDebts = (props: { debts: PropertiesDebt[] }) => {
  const { debts } = props

  if (!debts.length) {
    return <UnavailableCardContent message="No debts found" />
  }

  return (
    <Wrapper>
      {debts.map((debt, index) => {
        return <Debt key={index + 'debt'} debt={debt} />
      })}
    </Wrapper>
  )
}
